export default function PHP_is_double() {
  return (
    <div>
      <h1>PHP_is_double</h1>
    </div>
  );
}
